exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-frangn-wuddsdogg-tsx": () => import("./../../../src/pages/frangn-wuddsdogg.tsx" /* webpackChunkName: "component---src-pages-frangn-wuddsdogg-tsx" */),
  "component---src-pages-geschichte-tsx": () => import("./../../../src/pages/geschichte.tsx" /* webpackChunkName: "component---src-pages-geschichte-tsx" */),
  "component---src-pages-impressum-tsx": () => import("./../../../src/pages/impressum.tsx" /* webpackChunkName: "component---src-pages-impressum-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

